import { Entry, EntryCollection } from "contentful";
import {
  PlanBenefitTeaser,
  PlanBenefitTeaserComponent,
  PlanBenefitTeaserContainer,
} from "../models";
import { parseIntoImage } from "../utils";

const createPlanBenefit = (
  entry: Entry<PlanBenefitTeaser>,
): PlanBenefitTeaserComponent =>
  <PlanBenefitTeaserComponent>{
    planBenefitDescription: entry.fields.planBenefitDescription,
    planBenefitIcon: parseIntoImage({
      target: { ...entry.fields.planBenefitIcon },
    }),
    planBenefitLink: entry.fields.planBenefitLink,
    planBenefitTitle: entry.fields.planBenefitTitle,
    planBenefitId: entry.fields.planBenefitId,
  };

export const createPlanBenefitsList = (
  entries: EntryCollection<PlanBenefitTeaserContainer> | undefined,
): PlanBenefitTeaserComponent[] => {
  if (!entries) {
    console.error("no entries found for plan benefits teaser");
    return [];
  }

  const planBenefitTeasers: PlanBenefitTeaserComponent[] = [];

  const teasers = entries.items.at(0)?.fields.planBenefitsList;
  teasers?.forEach(entry => {
    planBenefitTeasers.push(createPlanBenefit(entry));
  });
  return planBenefitTeasers;
};
